// @flow
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import BasicSelect from "../formElements/basicSelect/basicSelect";
import InputField from "../formElements/inputField/inputField";
import Modal from "../modal/modal";
import styles from "./ticketingSuggestionModal.scss";
import {
  getAllTicketTypes,
  getBuTypes,
  getTicketTypeDTO,
  getGroupSuggestion
} from "./ticketingSuggestionModalRedux/ticketingSuggestionModalActionCreator";
import {
  enableOnlyNumberInput,
  isNullOrEmptyString
} from "../../../services/helpers";

type Props = {
  showModal: boolean,
  title: string,
  closeModal: Function,
  getBuTypes: Function,
  getAllTicketTypes: Function,
  getTicketTypeDTO: Function,
  ticketingSuggestionModalState: Object,
  getGroupSuggestion: Function,
  assignTicket: Function
};

type State = {
  buId: Integer,
  typeId: Integer,
  entityInput: string
};

class TicketingSuggestionModal extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      buId: null,
      typeId: null,
      entityInput: null,
      showSubmit: true
    };
  }

  componentDidMount() {
    this.props.getBuTypes();
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.props.ticketingSuggestionModalState.groupSuggestion.isLoaded &&
      nextProps.ticketingSuggestionModalState.groupSuggestion.isLoaded
    ) {
      this.setState({ showSubmit: false });
    }
  }

  onSubmit() {
    if (isNullOrEmptyString(this.state.buId)) {
      toastr.error("Please select business unit");
      return;
    }
    if (isNullOrEmptyString(this.state.typeId)) {
      toastr.error("Please select ticket type");
      return;
    }
    if (
      this.props.ticketingSuggestionModalState.ticketTypeDTO.isLoaded &&
      this.props.ticketingSuggestionModalState.ticketTypeDTO.data.entityType !==
        "NONE"
    ) {
      if (isNullOrEmptyString(this.state.entityInput)) {
        toastr.error("Please enter entity input");
        return;
      }
      this.props.getGroupSuggestion(this.state.typeId, this.state.entityInput);
    } else {
      this.props.getGroupSuggestion(this.state.typeId);
    }
  }

  getAssigneeName() {
    if (this.props.ticketingSuggestionModalState.groupSuggestion.data) {
      if (
        this.props.ticketingSuggestionModalState.groupSuggestion.data
          .groupList &&
        this.props.ticketingSuggestionModalState.groupSuggestion.data.groupList
          .length
      ) {
        return this.props.ticketingSuggestionModalState.groupSuggestion.data
          .groupList[0].name;
      } else if (
        this.props.ticketingSuggestionModalState.groupSuggestion.data
          .userList &&
        this.props.ticketingSuggestionModalState.groupSuggestion.data.userList
          .length
      ) {
        return this.props.ticketingSuggestionModalState.groupSuggestion.data
          .groupList[0].name;
      }
    }
    return null;
  }

  getBuSelectOptions(buTypes) {
    if (buTypes.isLoaded) {
      return buTypes.data.map(option => ({
        key: option.unitName,
        val: option.unitName,
        id: option.id
      }));
    }
    return [];
  }

  getTypeSelectOptions(ticketTypes) {
    const ticketTypesObjectToReturn = [];
    if (ticketTypes.isLoaded && ticketTypes.data) {
      ticketTypes.data.forEach(type => {
        ticketTypesObjectToReturn.push({
          key: type.key,
          val: type.key,
          id: type.val
        });
      });
    }
    return ticketTypesObjectToReturn;
  }

  assignTicketHelper() {
    if (this.props.ticketingSuggestionModalState.groupSuggestion.data) {
      if (
        this.props.ticketingSuggestionModalState.groupSuggestion.data
          .groupList &&
        this.props.ticketingSuggestionModalState.groupSuggestion.data.groupList
          .length
      ) {
        this.props.assignTicket({
          id: this.props.ticketingSuggestionModalState.groupSuggestion.data
            .groupList[0].id,
          type: "GROUP"
        });
      } else if (
        this.props.ticketingSuggestionModalState.groupSuggestion.data
          .userList &&
        this.props.ticketingSuggestionModalState.groupSuggestion.data.userList
          .length
      ) {
        this.props.assignTicket({
          id: this.props.ticketingSuggestionModalState.groupSuggestion.data
            .groupList[0].id,
          type: "USER"
        });
      }
    }
  }

  renderBuInput() {
    const { buTypes } = this.props.ticketingSuggestionModalState;
    return (
      <div>
        <div>
          <h2>Business Unit*</h2>
        </div>
        <div>
          <BasicSelect
            label="Select Unit"
            optionsArrOfObj={this.getBuSelectOptions(buTypes)}
            onSelect={(val, event) => {
              this.setState({ buId: event.id, showSubmit: true }, () =>
                this.props.getAllTicketTypes(this.state.buId)
              );
            }}
          />
        </div>
      </div>
    );
  }

  renderButtons() {
    if (this.state.showSubmit) {
      return (
        <div className={styles.button} onClick={() => this.onSubmit()}>
          Get Assignee Suggestion
        </div>
      );
    }
    if (!this.props.ticketingSuggestionModalState.groupSuggestion.data) {
      return (
        <div>
          <h2>No suggestion Found!</h2>
        </div>
      );
    }
    return (
      <div>
        <h2>
          Assignee Suggestion:
          {this.getAssigneeName()}
        </h2>
        <div
          className={styles.button}
          onClick={() => this.assignTicketHelper()}
        >
          Assign Ticket
        </div>
      </div>
    );
  }

  renderEntityInput() {
    const { ticketTypeDTO } = this.props.ticketingSuggestionModalState;
    return (
      <div>
        <div>
          <h2>{ticketTypeDTO.data.entityType}*</h2>
        </div>
        <div>
          <InputField
            placeholder={ticketTypeDTO.data.entityTypeDisplayName}
            type="text"
            disabled={false}
            onChange={val =>
              this.setState({ entityInput: val, showSubmit: true })
            }
            onKeyPress={event =>
              enableOnlyNumberInput(event, this.state.entityInput, null)
            }
          />
        </div>
      </div>
    );
  }

  renderTicketTypeInput() {
    const { ticketTypes } = this.props.ticketingSuggestionModalState;
    return (
      <div>
        <div>
          <h2>Issue Type*</h2>
        </div>
        <div>
          <BasicSelect
            label="Select type"
            enableSearch={true}
            showOptions={this.state.showTicketTypeOptions}
            optionsArrOfObj={this.getTypeSelectOptions(ticketTypes)}
            onSelect={(val, event) => {
              this.setState({ typeId: event.id, showSubmit: true }, () =>
                this.props.getTicketTypeDTO(this.state.typeId)
              );
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={this.props.closeModal}
      >
        <div className={styles.modalWrapper}>
          {this.renderBuInput()}
          {this.renderTicketTypeInput()}
          {this.props.ticketingSuggestionModalState.ticketTypeDTO.isLoaded &&
          this.props.ticketingSuggestionModalState.ticketTypeDTO.data
            .entityType !== "NONE"
            ? this.renderEntityInput()
            : null}
          {this.renderButtons()}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  ticketingSuggestionModalState: state.ticketingSuggestionModalState
});

const mapDispatchToProps = dispatch => ({
  getBuTypes: bindActionCreators(getBuTypes, dispatch),
  getAllTicketTypes: bindActionCreators(getAllTicketTypes, dispatch),
  getTicketTypeDTO: bindActionCreators(getTicketTypeDTO, dispatch),
  getGroupSuggestion: bindActionCreators(getGroupSuggestion, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketingSuggestionModal);



// WEBPACK FOOTER //
// ./app/components/commons/ticketingSuggestionModal/ticketingSuggestionModal.js